// src/pages/LegalPageLayout.jsx
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function LegalPageLayout({
  title,
  children,
  backTo = "/",
  backLabel = "Back",
  replaceBack = true,
}) {
  const location = useLocation();

  const effectiveBackTo = location.state?.backTo || backTo;
  const effectiveBackLabel = location.state?.backLabel || backLabel;
  const effectiveReplaceBack =
    typeof location.state?.replaceBack === "boolean"
      ? location.state.replaceBack
      : replaceBack;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="min-h-screen bg-[#FFF7ED] font-sans">
      <header
        className="bg-[#FF914D] text-white"
        style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
      >
        <div className="px-4 pt-2 pb-2 flex items-center justify-between">
          <Link
            to={effectiveBackTo}
            replace={effectiveReplaceBack}
            className="inline-flex items-center gap-2 px-3 py-1 rounded focus:outline-none focus:ring-2 focus:ring-white/60 hover:opacity-90"
            aria-label={effectiveBackLabel}
          >
            <span aria-hidden="true" className="text-2xl leading-none">
              ←
            </span>
            <span className="hidden sm:inline text-base">
              {effectiveBackLabel}
            </span>
          </Link>

          <img
            src="https://tknzgegeniiojzsascfl.supabase.co/storage/v1/object/public/pictures/Icon2.png"
            alt="Gwin logo"
            className="h-[60px] w-auto object-contain drop-shadow-sm select-none"
            loading="eager"
            decoding="async"
            draggable="false"
          />

          <span className="w-[52px]" aria-hidden="true" />
        </div>

        <div className="text-center pb-6 px-4">
          <h2 className="text-[32px] md:text-[40px] font-sans font-semibold leading-tight">
            {title}
          </h2>
        </div>
      </header>

      <main className="px-5 py-8 md:px-8 md:py-12 max-w-5xl mx-auto text-[#333333]">
        <div className="rounded-3xl border border-[#FFE1CF] bg-white shadow-sm p-6 md:p-9">
          {children}
        </div>
      </main>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section className="mb-9 last:mb-0">
      <h3 className="text-2xl md:text-3xl font-bold mb-4 text-[#333333]">
        {title}
      </h3>

      <div className="text-base md:text-lg leading-relaxed text-[#4B5563]">
        {children}
      </div>
    </section>
  );
}